import React, { useState } from "react";

import store from "../catalog/app/redux/store";
import * as Actions from "../catalog/app/redux/actions";

const ChangePassword = ({ setForgetPwd }) => {
  const [forgetEmail, setForgetEmail] = useState("");
  const [emailError, setEmailError] = useState({ status: false, message: "" });

  const [sendEmailStatus, setSendEmailStatus] = useState({
    status: false,
    email: "",
  });

  const emailValidation = (email) => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      setEmailError({
        status: true,
        message: "Correo electronico no es correcto",
      });
      return false;
    }
    setEmailError({ status: false, message: "" });
    return true;
  };

  const handleSubmitChangePWD = (event) => {
    event.preventDefault();

    store.dispatch(Actions.confirmEmail(forgetEmail)).then((data) => {
      const email = data.payload.data;

      if (email.length > 0) {
        setSendEmailStatus({ status: true, email: email[0].email });

      } else {
        setSendEmailStatus(false);
        setEmailError({
          status: true,
          message: "Correo electronico no existe en usuarios",
        });

        console.log("no email");
      }
    });
  };

  return (
    <div>
      {sendEmailStatus.status && (
        <div className="send-recover-email">
          <div className="info">
            Informaciones sobre nueva contraseña enviado a correo
            {`${sendEmailStatus.email}`}
          </div>
        </div>
      )}
      {!sendEmailStatus.status && (
        <div className="content">
          <form onSubmit={(event) => handleSubmitChangePWD(event)}>
            <div className="user-email">
              <label htmlFor="user_login" className="user_pwd_login">
                Nombre de correo electrónico
              </label>
              <input
                name="user_login"
                type="text"
                placeholder="E-mail"
                onChange={(e) => {
                  emailValidation(e.target.value);
                  setForgetEmail(e.target.value);
                }}
              />
              {emailError.status && (
                <span className="error-massage">{emailError.message}</span>
              )}
            </div>
            <p className="submit-change-pwd">
              <input type="submit" value="Obtener nueva contraseña" />
            </p>
          </form>
          <div className="nav" onClick={() => setForgetPwd(false)}>
            <div>Acceder</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
